import React from "react";
import { useNavigate } from "react-router-dom";
import ShopifySVG from "../../../../assets/svg/shopify.svg";
import { ROUTE_DESTINATIONS_CREATE } from "../../../../constants/routes";

const ShopifyCard = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-gradient-to-br from-[#96bf48] to-[#5e8e3e] text-white border rounded-md max-w-xs p-4 flex flex-col gap-4 shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-200">
      <img
        alt="wordpress-logo"
        src={ShopifySVG}
        className="size-16"
      />
      <div className="font-semibold">Shopify</div>
      <div className="text-white text-sm">
        Share your generated articles right into your shopify account
      </div>
      <button
        className="text-[#5e8e3e] bg-white rounded px-4 py-2 font-semibold hover:bg-gray-200 transition duration-200 shadow-sm"
        onClick={() => navigate(ROUTE_DESTINATIONS_CREATE + "?type=shopify")}
      >
        Add
      </button>
    </div>
  );
};

export default ShopifyCard;
